var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-4 px-4",attrs:{"fluid":""}},[_c('GlobalActivityFeed')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }